import { render, staticRenderFns } from "./TeacherCertificateList.vue?vue&type=template&id=6b96583f&scoped=true&"
import script from "./TeacherCertificateList.vue?vue&type=script&lang=js&"
export * from "./TeacherCertificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96583f",
  null
  
)

export default component.exports